import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { trackPageView } from '../../page/page-actions';


const MetricsMeta = ({ slugInfo, trackPageView }) => {

    const { analyticsData, vanityUrl } = slugInfo || {};
    const { page_level, product_type, family, bu, segment, lifecycle, simple_title } = analyticsData || {};

    useEffect(() => {
        if(vanityUrl && slugInfo) {
            trackPageView(slugInfo);
        }
    }, [vanityUrl]);

    return analyticsData ? (
        <Helmet>
            <meta name="hp_design_version" content="global_ux" />
            <meta name="simple_title" content={ simple_title || '' } />
            <meta name="page_level" content={ page_level || ''} />
            <meta name="product_type" content={product_type || ''} />
            <meta name="family" content={family || ''} />
            <meta name="bu" content={bu || ''} />
            <meta name="segment" content={segment || ''} />
            <meta name="lifecycle" content={lifecycle || ''} />
        </Helmet>
    ) : null;
};

const mapStateToProps = state => ({ slugInfo: state && state.slugInfo });
const mapDispatchToProps = dispatch => ({ trackPageView: slugInfo => dispatch(trackPageView(slugInfo, true)) });
export default connect(mapStateToProps, mapDispatchToProps)(MetricsMeta);